import { AppRoutes } from 'config';
import { ListCardStyle } from 'types';
import { joinRoutes, formatPrice } from 'utils/helpers';
import { EventReport, EventProfitAndLoss } from 'store/api/event';

const { Profile, Employees } = AppRoutes;

export const revenueTitles = ['Date', 'Check', 'Cash', 'Net Credit', 'Tip'];
export const expensesTitles = ['Category Name', 'Amount'];
export const expensesTemplate = 'repeat(2, 1fr)';

export const commonProps = {
  hasMinHeight: true,
  mainWrapperStyles: { padding: 0 },
};

export const calculatePaymentMethods = (eventReports?: EventReport[]) =>
  eventReports?.reduce(
    (acc, report) => {
      for (const [method, amount] of Object.entries(report?.paymentMethods)) {
        acc[method] += amount;
      }
      return acc;
    },
    { cash: 0, check: 0, credit: 0 } as Record<string, any>
  );

export const commonFooterCardProps = {
  isOdd: true,
  selected: true,
  odd: ListCardStyle.Default,
};

export const LTL_EXPENSE_NAME = 'LTL';

// Stock order LTL and stock transfer LTL are one P&L line (Owner request).
export const getCombinedLtlAmount = (data?: EventProfitAndLoss) =>
  data
    ? Number(data.totalLTLStockOrders || 0) +
      Number(data.totalLTLStockTransfers || 0)
    : undefined;

export const getExpensesInfo = (data?: EventProfitAndLoss) => [
  { name: 'Commissions', amount: data?.totalCommissions },
  { name: 'Tax', amount: data?.totalTax },
  { name: 'Processing Fee', amount: data?.totalProcessingFees },
  { name: 'Product Cost', amount: data?.totalProductSoldCost },
  { name: LTL_EXPENSE_NAME, amount: getCombinedLtlAmount(data) },
  { name: 'Reimbursements', amount: data?.totalReimbursements },
  { name: 'Bonuses', amount: data?.totalBonuses },
  { name: 'Locations Rent', amount: data?.totalLocationsRent },
  { name: 'Electricity', amount: data?.totalElectricity },
  { name: 'COI', amount: data?.totalCOI },
  { name: 'Shipment Cost', amount: data?.totalShipmentCost },
];

export const getSummaryInfo = (data?: EventProfitAndLoss) => [
  { title: 'Gross Revenue', value: formatPrice(data?.totalGrossSales) },
  { title: 'Net Revenue', value: formatPrice(data?.totalNetSales) },
  { title: 'Working Days', value: data?.workingDays },
  { title: 'Profit', value: formatPrice(data?.profit) },
  {
    title: 'Profit Percentage',
    value: data?.profitPercentage && `${data?.profitPercentage}%`,
  },
  {
    title: 'PRP',
    value:
      data?.productRevenuePercentage && `${data?.productRevenuePercentage}%`,
  },
];

export const revenueCellsTablet = [
  { row: '1/2', col: '1/3' },
  { row: '1/2', col: '3/4' },
  { row: '2/3', col: '1/2' },
  { row: '2/3', col: '2/3' },
  { row: '2/3', col: '3/4' },
];

export const employeePaymentsRoute = joinRoutes([
  Employees.Home,
  Employees.Details,
  Profile.Payments,
]);
